import { Component, OnInit } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { UserService } from '../../providers/user.service';
import { IPlanning } from '../../../typings/timetracker/timetracker';
import { Observable } from 'rxjs/Observable';
import { IActivityTotalResponse } from '../../../typings/api';

/**
 * Generated class for the DailyTotalsDetailsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-daily-totals-details',
  templateUrl: 'daily-totals-details.html',
})
export class DailyTotalsDetailsPage implements OnInit {

  private activityTotal$: Observable<IActivityTotalResponse>;
  private planning;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public userService$: UserService
  ) {
    this.planning = ( navParams.data as IPlanning );
  }

  ngOnInit(): void {
    this.activityTotal$ = this.userService$.selectUserListDailyActivityTotals();
    console.log( '[DAILY-TOTALS]', this.planning );
    this.userService$.dispatchUserListDailyActivityTotals( this.planning.year, this.planning.iso_week, this.planning.iso_weekday );
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad DailyTotalsDetailsPage');
  }
}



// WEBPACK FOOTER //
// ./src/pages/daily-totals-details/daily-totals-details.ts